// src/translations/contact.js
export default {
  en: {
    section_title: "Get in Touch",
    section_subtitle: "Let's Talk Real Estate",
    section_description: "Whether you're ready to buy, sell, or invest, I'm here to guide you. Reach out today and let's explore your real estate goals together.",
    email_label: "Email",
    email_subtitle: "Response within 24 hours",
    phone_label: "Phone",
    contact_note: "Available: Monday - Saturday, 9:00 AM - 7:00 PM",
    
    faq_title: "Frequently Asked Questions",
    
    faq1_question: "How quickly do you respond?",
    faq1_answer: "I typically respond within 24 hours, often much faster. For urgent inquiries, call me directly on my mobile.",
    
    faq2_question: "Can you visit my property?",
    faq2_answer: "Absolutely! I can schedule a viewing based on your availability. Just reach out and we'll arrange an appointment that works for you.",
    
    faq3_question: "What areas do you cover?",
    faq3_answer: "I work primarily throughout the region with established expertise in the local market. For properties in nearby areas, I can evaluate the possibility of assisting you.",

    faq4_question: "What's your typical process?",
    faq4_answer: "I start with a detailed consultation to understand your needs, then provide personalized solutions. From property search to closing, I guide you every step of the way."
  },
  it: {
    section_title: "Contattami",
    section_subtitle: "Parliamo di Immobiliare",
    section_description: "Che tu sia pronto per comprare, vendere o investire, sono qui per guidarti. Contattami oggi e scopriamo insieme i tuoi obiettivi immobiliari.",
    email_label: "Email",
    email_subtitle: "Risposta entro 24 ore",
    phone_label: "Telefono",
    contact_note: "Disponibile: Lunedì - Sabato, 9:00 - 19:00",
    
    faq_title: "Domande Frequenti",
    
    faq1_question: "In quanto tempo rispondi?",
    faq1_answer: "Rispondo generalmente entro 24 ore, spesso molto più velocemente. Per richieste urgenti, chiamami direttamente al cellulare.",
    
    faq2_question: "Puoi venire a vedere la mia proprietà?",
    faq2_answer: "Certamente! Posso organizzare una visita in base alla tua disponibilità. Contattami e troveremo un momento che va bene per te.",
    
    faq3_question: "Quali zone copri?",
    faq3_answer: "Lavoro principalmente nella regione con esperienza consolidata nel mercato locale. Per proprietà in zone limitrofe, posso valutare la possibilità di assisterti.",

    faq4_question: "Qual è il tuo processo?",
    faq4_answer: "Comincio con una consulenza dettagliata per capire le tue esigenze, poi fornisco soluzioni personalizzate. Dalla ricerca della proprietà alla chiusura, ti guido in ogni fase."
  }
};